import { call, put, takeEvery } from 'redux-saga/effects';
import { GET_USER_ADDRESS_REQUEST } from '../../constants/user_address.constants';
import { getUserProfileAddresses } from '../../../requests/user_addresses_requests/get_user_addresses_request';
import { getUserAddressRequestSuccess, getUserAddressRequestFailure } from '../../actions/user_addresses_actions/common_export';
import { message_error } from '../../../../../../components/Message';

function* getUserAddressRequest({ _id }) {
    const {
        result, msg, options, error,
    } = yield call(getUserProfileAddresses, _id);
    if (result) {
        yield put(getUserAddressRequestSuccess(options.person.addresses));
    } else {
        yield put(getUserAddressRequestFailure(error));
        message_error(msg);
    }
}

export default function* getUserAddressSaga() {
    yield takeEvery(GET_USER_ADDRESS_REQUEST, getUserAddressRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_addresses_sagas/get_user_address.saga.js